import axios from "../http";
import { handleGetRequestParams } from '@/common/js/util'

class Financial {
  /* 财务列表 */
  static getFinancial(type, pageNo, billDate, customerId, warehouseId, projectId, startDate, endDate, status) {
    const url = `/oa/api/bill/list?type=${type}&pageNo=${pageNo}&billDate=${billDate}&customerId=${customerId}&warehouseId=${warehouseId}&projectId=${projectId}&startDate=${startDate}&endDate=${endDate}&status=${status}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单详情 */
  static getDetails(option) {
    let url = `/oa/api/bill/detail/by/date/project?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });

  }
  /* 调整明细费用 */
  static postAdjust(data) {
    const url = `/oa/api/bill/adjust`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 调整记录列表 */
  static getRecordsList(option) {
    let url = `/oa/api/bill/list/adjust?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 登记记录列表 */
  static getLoginRecordsList(billDate, projectId, chargeServiceId) {
    const url = `/oa/api/charge/check/bill/list?billDate=${billDate}&projectId=${projectId}&chargeServiceId=${chargeServiceId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑其他费用 */
  static postModifyOther(data) {
    const url = `/oa/api/bill/modify/other`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 核实账单 */
  static postVerify(data) {
    const url = `/oa/api/bill/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单批量核实 */
  static postBatchVerification(data) {
    const url = `/oa/api/bill/batch/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改备注 */
  static postModifyRemarks(data) {
    const url = `/oa/api/bill/modify/remarks`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改附件 */
  static postModifyAttachments(data) {
    const url = `/oa/api/bill/modify/attachments`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 索赔记录列表 */
  static getCliamRecordsList(billDate, projectId) {
    const url = `/oa/api/charge/check/list/claim/bill?billDate=${billDate}&projectId=${projectId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导出账单 */
  static getExport(data, type) {
    let url
    if (type === 2) {
      url = `/oa/api/download/bill/month`;
    } else {
      url = `/oa/api/download/bill/day`;
    }
    return axios.post(url, data, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 账单重算 */
  static postBillRecalculation(data) {
    const url = `/oa/api/bill/handle/bill`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Financial;